import { __decorate, __extends } from "tslib";
import { Injectable } from '@angular/core';
import { AwesomeCordovaNativePlugin, cordova } from '@awesome-cordova-plugins/core';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
var PreviewAnyFile = /** @class */ (function (_super) {
    __extends(PreviewAnyFile, _super);
    function PreviewAnyFile() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PreviewAnyFile.prototype.preview = function (url) { return cordova(this, "preview", {}, arguments); };
    PreviewAnyFile.prototype.previewPath = function (path, opt) {
        if (opt === void 0) { opt = {}; }
        return cordova(this, "previewPath", { "observable": true, "callbackOrder": "reverse" }, arguments);
    };
    PreviewAnyFile.prototype.previewBase64 = function (base64, opt) {
        if (opt === void 0) { opt = {}; }
        return cordova(this, "previewBase64", { "observable": true, "callbackOrder": "reverse" }, arguments);
    };
    PreviewAnyFile.prototype.previewAsset = function (path, opt) {
        if (opt === void 0) { opt = {}; }
        return cordova(this, "previewAsset", { "observable": true, "callbackOrder": "reverse" }, arguments);
    };
    PreviewAnyFile.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PreviewAnyFile, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
    PreviewAnyFile.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PreviewAnyFile });
    PreviewAnyFile.pluginName = "Preview/Open Any File";
    PreviewAnyFile.plugin = "cordova-plugin-preview-any-file";
    PreviewAnyFile.pluginRef = "PreviewAnyFile";
    PreviewAnyFile.repo = "https://github.com/mostafa-mansour1/previewAnyFile";
    PreviewAnyFile.install = "";
    PreviewAnyFile.installVariables = [];
    PreviewAnyFile.platforms = ["Android", "iOS"];
    PreviewAnyFile = __decorate([], PreviewAnyFile);
    return PreviewAnyFile;
}(AwesomeCordovaNativePlugin));
export { PreviewAnyFile };
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.16", ngImport: i0, type: PreviewAnyFile, decorators: [{
            type: Injectable
        }], propDecorators: { preview: [], previewPath: [], previewBase64: [], previewAsset: [] } });
